export const isUndefined = <T>(val: T | undefined): val is undefined => val === undefined
